import overlayBg from "@/assets/overlay-bg.mp4";

export const VideoBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden z-0 pointer-events-none">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover opacity-60"
      >
        <source src={overlayBg} type="video/mp4" />
      </video>
      <div className="absolute inset-0 bg-background/50" />
    </div>
  );
};
